import { TextField } from "@mui/material";
import React, { useState } from "react";
import toast from "react-hot-toast";
import InfoIcon from "@mui/icons-material/Info";
import formatDateAndTime from "../../common/formatDateAndTime";

const Addtransactions = ({
  summaryDetails,
  paymentDetailsData,
  selectedRow,
  getBookingDetail,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [transactiondetails, settransactiodetails] = useState({
    transactionid: "",
    transactioncharges: "",
    paymentmode: "",
    payableamount: "",
    paymentremarks: "",
    attachments: null,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [paymentLink, setPaymentLink] = useState(null);
  const [paymentSavedDetails, setPaymentSavedDetails] = useState(null);

  const transactionDetailsInput = [
    {
      label: "Transaction Id",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactionid",
      defaultValue: "",
    },
    {
      label: "Transaction Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactioncharges",
      defaultValue: "",
    },
    {
      label: "Payment Mode",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentmode",
      defaultValue: "",
    },
    {
      label: "Payable Amount",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "payableamount",
      defaultValue: `Pending Amount : ₹  ${
        paymentDetailsData?.pendingAmount ? Number((paymentDetailsData?.pendingAmount).toFixed(2)) : 0
      }`,
    },
    {
      label: "Payment Remarks",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentremarks",
      defaultValue: "",
    },
    {
      label: "Attachments",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "attachments",
    },
  ];

  const validateField = (key, value) => {
    let errorMsg = "";

    if (key === "transactioncharges" && !/^\d+$/.test(value)) {
      errorMsg = "* Accepts only numbers";
    }
    if (key === "payableamount" && !/^\d+(\.\d{1,2})?$/.test(value)) {
      errorMsg = "* Accepts only numbers (up to 2 decimals)";
    }
    if (key === "documentype" && !value) {
      errorMsg = "Please select a document type";
    }
    if (key === "paymentmode" && !/^[a-zA-Z]*$/.test(value)) {
      errorMsg = "* Accepts only alphabets";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  const handleInputChange = async (key, event) => {
    let value;

    if (event?.target?.type === "file") {
      value = event.target.files[0];

      if (value) {
        const formData = new FormData();
        formData.append("entityName", "booking");
        formData.append("fileTags", "vehicle");
        formData.append("files", value);

        try {
          const response = await fetch(`${apiUrl}/fileapi/upload`, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data) {
            toast.success("Image Uploaded successfully.", {
              position: "bottom-center",
              style: {
                background: "blue", // override background
                color: "white",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
            setSelectedFile(data?.uploaded);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    } else {
      value = event?.target?.value !== undefined ? event.target.value : event;

      settransactiodetails((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
    validateField(key, value);
  };
  

  const generatepaymentlink = async (type) => {
    let payload;

    if (type === "generate") {
      payload = {
        bookingId: summaryDetails?.id,
        amount: Math.round(summaryDetails?.costToCustomer * 100),
        customerName: summaryDetails?.customerName,
        contactEmail: summaryDetails?.customerEmail,
        customerContact: summaryDetails?.customerMobile,
        customerId: summaryDetails?.customerId,
      };
    } else {
      payload = {
        paymentId: paymentLink?.paymentId,
        id: paymentLink?.id,
        bookingId: summaryDetails?.id,
        inquiryCode: summaryDetails?.inquiryCode,
      };
    }

    try {
      const response = await fetch(`${apiUrl}/api/paymentlinks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        if (data?.dataValues?.status === "created") {
          toast.success("Payment link generated successfully.");
        } else {
          toast.success("Payment Captured successfully.");
          getBookingDetail(selectedRow?.inquiryID, "inquiry");
        }
        setPaymentLink(data?.dataValues);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching generate payment link:", error);
    }
  };

  const addTransactions = async () => {
    let isValid = true;
    const newErrors = {};

    // Required fields
    const requiredFields = [
      "transactionid",
      "transactioncharges",
      "paymentmode",
      "payableamount",
      "paymentremarks",
    ];

    requiredFields.forEach((field) => {
      if (!transactiondetails[field]) {
        newErrors[field] = "* Required";
        isValid = false;
      } else {
        const valid = validateField(field, transactiondetails[field]);
        if (!valid) isValid = false;
      }
    });

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix errors before submitting payment details");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/api/bookingtransactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          amount: transactiondetails?.payableamount,
          paymentMode: transactiondetails?.paymentmode,
          transactionCode: transactiondetails?.transactionid,
          transactionalCharges: transactiondetails?.transactioncharges,
          bookingId: summaryDetails?.id,
          description: transactiondetails?.paymentremarks,
          attachments: JSON.stringify(selectedFile) || null,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Payment Saved successfully.");
        setPaymentSavedDetails(data?.dataValues);
        getBookingDetail(paymentDetailsData?.inquiryCode, "inquiry");
        // getBookingDetail(paymentDetailsData?.bookingCode, "booking");
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error
      );
    }
  };

  return (
    <div className="p-2">
      <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
        Add Transactions
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 p-2 gap-4 my-4">
        {transactionDetailsInput.map((input, index) => (
          <div key={index}>
            {input.type === "file" ? (
              <input
                type="file"
                accept="image/*" // or any file type
                onChange={(e) => handleInputChange(input.value, e)}
              />
            ) : (
              <>
              <TextField
                fullWidth
                type={input.type}
                label={input.label}
                disabled={input?.isEnable}
                value={transactiondetails[input.value] || ""}
                onChange={(e) => handleInputChange(input.value, e)}
                error={!!errors[input.value]}
                helperText={errors[input.value]}
                InputLabelProps={{ shrink: true }}
              /> 
              {/* {<p className="text-gray-500 text-sm mt-2">{input?.defaultValue}</p>}   */}
              </>           
            )}
          </div>
        ))}
      </div>
      <div className="flex justify-end gap-4">
        <button
          onClick={() => {
            generatepaymentlink("generate");
          }}
          class="cursor-pointer text-white font-bold relative text-[14px] w-[14em] h-[3em] text-center bg-gradient-to-r from-violet-500 from-10% via-sky-500 via-30% to-pink-500 to-90% bg-[length:400%] rounded-[30px] z-10 hover:animate-gradient-xy hover:bg-[length:100%] before:content-[''] before:absolute before:-top-[5px] before:-bottom-[5px] before:-left-[5px] before:-right-[5px] before:bg-gradient-to-r before:from-violet-500 before:from-10% before:via-sky-500 before:via-30% before:to-pink-500 before:bg-[length:400%] before:-z-10 before:rounded-[35px] before:hover:blur-xl before:transition-all before:ease-in-out before:duration-[1s] before:hover:bg-[length:10%] active:bg-violet-700 focus:ring-violet-700 hover:brightness-110 hover:-translate-y-[1px] active:brightness-90 active:translate-y-[2px]"
        >
          + Generate Payment Link
        </button>

        <button
          onClick={addTransactions}
          disabled={
            ![
              "transactionid",
              "transactioncharges",
              "paymentmode",
              "payableamount",
              "paymentremarks",
            ].every(
              (key) =>
                transactiondetails[key] !== null &&
                transactiondetails[key] !== undefined &&
                transactiondetails[key] !== ""
            )
          }
          className={`relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-teal-50 
      bg-gradient-to-tr from-teal-900/50 via-teal-900/90 to-teal-900/30 ring-4 ring-teal-900/20 
      rounded-full overflow-hidden hover:opacity-90 transition-opacity 
      before:absolute before:top-4 before:left-1/2 before:-translate-x-1/2 
      before:w-[100px] before:h-[100px] before:rounded-full before:bg-gradient-to-b 
      before:from-teal-50/10 before:blur-xl
      ${
        ![
          "transactionid",
          "transactioncharges",
          "paymentmode",
          "payableamount",
          "paymentremarks",
        ].every(
          (key) =>
            transactiondetails[key] !== null &&
            transactiondetails[key] !== undefined &&
            transactiondetails[key] !== ""
        )
          ? "opacity-50 cursor-not-allowed"
          : ""
      }`}
        >
          + Add Payment
        </button>
      </div>
      {paymentLink && (
        <table className="min-w-full text-sm text-left shadow-lg border border-gray-100 mt-8">
          <thead className="">
            <tr>
              <th className="p-4">Payment Id</th>
              <th className="p-4">Total Amount</th>
              <th className="p-4">Payment Url</th>
              <th className="p-4">Status</th>
              <th className="p-4">Generated At</th>
              <th className="p-4 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paymentLink ? (
              <tr key={paymentLink?.id} className="border-b hover:bg-gray-50">
                <td className="p-4">{paymentLink?.paymentId}</td>
                <td className="p-4">{"₹ " + paymentLink?.amount}</td>
                <td className="p-4">{paymentLink?.shortUrl}</td>
                <td className="p-4">{paymentLink?.status}</td>
                <td className="p-4">
                  {formatDateAndTime(paymentLink?.createdAt)}
                </td>
                <td
                  onClick={() => {
                    generatepaymentlink("actions");
                  }}
                  className="p-4 text-right cursor-pointer"
                >
                  <InfoIcon />
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan="6" className="text-center p-4 text-gray-500">
                  No payment links found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Addtransactions;
